import { Media } from "@/models/media";

export class Video extends Media {
   url?: string;
   src?: string;
   title?: string;
   thumb?: string;

  public static of(v: { url: string, thumbnailUrl?: string }, name: string): Video {
    const video = new Video();
    video.url = v.url;
    video.src = v.url;
    video.title = name;
    video.thumb = v.thumbnailUrl;
    return video;
  }
}
